import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/services/auth.service';
import { Component } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    // { title: 'Dashboard', url: '/dashboard', icon: 'stats-chart' },
    { title: 'Classes', url: '/classes', icon: 'list' },
    // { title: 'Calendar', url: '/calendar', icon: 'calendar' },
    { title: 'Events', url: '/events', icon: 'alarm' },
    { title: 'Push Notifications', url: '/push-notifications', icon: 'notifications' },
  ];
  constructor(
    private auth: AuthService,
    private cookieService: CookieService,
    private router: Router
  ) {
    this.auth.checkAuthState();
  }

  logOut() {
    this.cookieService.deleteAll();
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
